export default "__VITE_ASSET__e9Izoi2h__"